import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight, Linkedin } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-50 text-slate-700 mt-32 border-t border-slate-200">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo testId="footer-logo" />
            <p className="mt-6 max-w-md text-slate-600 text-base leading-relaxed">
              We connect forward-thinking companies with exceptional talent across BPO and high-end technology — at the right time, at the right scale.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-button"
              className="mt-8 inline-flex items-center gap-2 bg-[#00E676] text-slate-900 px-5 py-3 text-sm font-semibold hover:bg-[#00C853] transition-colors"
            >
              Start a Conversation
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="label-eyebrow text-slate-500">Explore</div>
            <ul className="mt-4 space-y-3">
              {[
                { to: "/about", label: "About", id: "about" },
                { to: "/services", label: "BPO Hiring", id: "services" },
                { to: "/technologies", label: "Technology Hiring", id: "technologies" },
                { to: "/contact", label: "Contact", id: "contact" },
              ].map((l) => (
                <li key={l.id}>
                  <Link to={l.to} data-testid={`footer-link-${l.id}`} className="text-slate-600 hover:text-slate-900 transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="label-eyebrow text-slate-500">Contact</div>
            <ul className="mt-4 space-y-3 text-slate-700 text-sm">
              <li className="flex items-start gap-3" data-testid="footer-email">
                <Mail className="h-4 w-4 mt-0.5 text-[#00C853]" />
                <a href="mailto:Info@raprosolutions.com" className="hover:text-slate-900 transition-colors">Info@raprosolutions.com</a>
              </li>
              <li className="flex items-start gap-3" data-testid="footer-address">
                <MapPin className="h-4 w-4 mt-0.5 text-[#00C853]" />
                <span>3rd Floor, Lakshmi Complex, Gnana Jyothi Nagar, Ullal Main Road, Bangalore — 560056</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-slate-500 tracking-wider uppercase">
            © {new Date().getFullYear()} RAPRO Solutions. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-slate-500">
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              data-testid="footer-linkedin"
              className="hover:text-slate-900 transition-colors"
            >
              <Linkedin className="h-4 w-4" />
            </a>
            <a
              href="https://www.raprosolutions.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-website"
              className="text-xs uppercase tracking-widest hover:text-slate-900 transition-colors"
            >
              raprosolutions.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
